import {
    GET_EXAM_ROOMS_FAIL,
    GET_EXAM_ROOMS_SUCCESS,
    ADD_EXAM_ROOM_SUCCESS,
    ADD_EXAM_ROOM_FAIL,
    UPDATE_EXAM_ROOM_SUCCESS,
    UPDATE_EXAM_ROOM_FAIL,
    DELETE_EXAM_ROOM_SUCCESS,
    DELETE_EXAM_ROOM_FAIL,
    RESET_EXAM_ROOM_LAST_ACTION_SUCCESS,
    CHECK_EXAM_ROOM_AVAILABILITY_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
    examRooms: [],
    error: null,
    loading: true,
    success: false
};

const examRoomReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des examRooms
        case GET_EXAM_ROOMS_SUCCESS:
            return {
                ...state,
                examRooms: action.payload, // tableau d'objets examRoom
                loading: false,
                error: null
            };

        case GET_EXAM_ROOMS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une examRoome
        case ADD_EXAM_ROOM_SUCCESS:
            return {
                ...state,
                examRooms: [action.payload, ...state.examRooms], // ajoute au début du tableau
                error: null,
                success: true
            };

        case ADD_EXAM_ROOM_FAIL:
            return {
                ...state,
                error: action.payload,
                 success: false
            };

        // Mise à jour d'une examRoome
        case UPDATE_EXAM_ROOM_SUCCESS:
            return {
                ...state,
                examRooms: state.examRooms.map(examRoom =>
                    examRoom.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet examRoom
                        : examRoom
                ),
                error: null,
                 success: true
            };

        case UPDATE_EXAM_ROOM_FAIL:
            return {
                ...state,
                error: action.payload,
                 success: false
            };

        // Suppression d'une examRoome
        case DELETE_EXAM_ROOM_SUCCESS:
            return {
                ...state,
                examRooms: state.examRooms.filter(
                    examRoom => examRoom.id !== action.payload
                ),
                error: null
            };


        case DELETE_EXAM_ROOM_FAIL:
            return {
                ...state,
                error: action.payload
            };
        // ─── Disponibilité ────────────────────────────────────────────────────
        case CHECK_EXAM_ROOM_AVAILABILITY_SUCCESS:
            return { ...state, availability: action.payload };

        case RESET_EXAM_ROOM_LAST_ACTION_SUCCESS:
            return { 
                ...state, 
                success: false 
            };


        default:
            return state;
    }
};

export default examRoomReducer;
